import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tag__content" }

import { computed } from 'vue';
import { ArrivalStatus, OrderStatus } from '@/coreDomainsModule/entities/arrival';
import { i18n } from '@/i18n';

//i18n
interface Props {
  status: ArrivalStatus | OrderStatus;
  label?: string; // 表示テキストを上書きする場合に使用
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RecommendTag',
  props: {
    status: {},
    label: {}
  },
  setup(__props: any) {

const t = i18n.t;
/**
 * propsの定義
 */
const props = __props;

const text = computed(() => {
  // ArrivalStatusとOrderStatusで分岐させる
  switch (props.status) {
    case ArrivalStatus.Unpaid:
      return t('未納');
    case ArrivalStatus.ApprovalRequested || OrderStatus.ApprovalRequested:
      return t('承認依頼タグ');
    case ArrivalStatus.Recommended || OrderStatus.Recommended:
      return t('推奨タグ');
    case OrderStatus.ApprovedAwaitingDeliveryDate:
      return t('承認済');
    default:
      return '';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`tag tag--${_ctx.status.toLowerCase()}`)
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(props.label ?? text.value), 1)
  ], 2))
}
}

})